const faqs = [
  { q: "Which files can I upload?", a: "JPG, JPEG, PNG, WEBP and PDF (including scanned PDFs). Up to 10 files per batch, 15 MB each." },
  { q: "How are multi-page statements handled?", a: "Every page is rasterised, preprocessed and extracted separately, then all transactions are combined with Source File and Source Page tracked on each row." },
  { q: "What does the yellow highlight mean?", a: "The cell was extracted with low OCR confidence or is missing a value (Needs Review). Click it to correct the value and save — all analytics recalculate." },
  { q: "Why does the app say 'Bank format detected as Generic'?", a: "The bank could not be confidently identified from the header, name or IFSC. Processing continues with the generic parser." },
  { q: "Are the analytics a lending decision?", a: "No. Estimated income, business credits, EMI and Cash Flow Stability are analytical indicators with visible underlying factors. They must be independently reviewed." },
  { q: "How are duplicates handled?", a: "Rows matching on date, amount, description and reference are flagged as Potential Duplicate. Nothing is deleted automatically — you decide in the transaction table." },
];

export default function Help() {
  return (
    <div className="max-w-3xl space-y-6" data-testid="help-page">
      <div>
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground">Support</p>
        <h1 className="mt-2 font-display text-3xl font-extrabold tracking-tighter">Help</h1>
      </div>
      <div className="grid gap-4">
        {faqs.map((f) => (
          <div key={f.q} className="rounded-lg border border-border bg-white p-5">
            <h2 className="font-display text-base font-semibold">{f.q}</h2>
            <p className="mt-2 text-sm text-muted-foreground">{f.a}</p>
          </div>
        ))}
      </div>
      <div className="rounded-lg border border-warn-border bg-warn p-4 text-xs text-warn-foreground">
        Analytical estimates are generated from extracted bank-statement data and may contain OCR or
        classification errors. Users should verify important information against the original statement.
      </div>
    </div>
  );
}
